export default __webpack_public_path__ + "static/media/quad@3x.832bcebe.png";